<template>
    <div class="w-full">
        <CustomTable :data="requests" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-x-[8px]">
                        <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                            <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                        </button>
                        <div class="inline-block relative">
                            <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                                <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                                Filtres
                            </button>
                            <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                                <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                    <div class="flex items-center gap-x-[8px]">
                                        <label for="début" class="font-light">Début:</label>
                                        <input type="date" v-model="toSend.start" name="début" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                    </div>
                                    <div class="flex items-center gap-x-[8px]">
                                        <label for="fin" class="font-light">Fin:</label>
                                        <input type="date" v-model="toSend.end" name="début" class="h-[35px] p-3 w-[130px] cursor-pointer rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                    </div>
                                    <button v-on:click="getData" :disabled="table_load || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                        Actualiser
                                    </button>
                                    <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                        <X :size="16" strokeWidth="1.3"/>
                                    </button>
                                </div>
                            </Transition>
                        </div>

                        <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':filter_status == 'attente'}]" @click="selectFilter('0','attente')">
                            <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                            En attente
                        </button>

                        <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':filter_status == 'validated'}]" @click="selectFilter('1','validated')">
                            <Check :size="16" strokeWidth="1.3"/>
                            Acceptées
                        </button>

                        <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':filter_status == 'rejected'}]" @click="selectFilter('2','rejected')">
                            <X :size="16" strokeWidth="1.3"/>
                            Rejetées
                        </button>
                    </div>
                    <button class="bg-[#3c41e9] font-light gap-x-[8px] rounded-xl text-white px-4 h-[35px] flex items-center justify-center">
                        <FolderUp :size="16"/>
                        Exporter
                    </button>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 0" class="flex items-center gap-x-[8px]">
                     <!-- <input type="checkbox" :value="Number(slotProps.value.split('/')[2])" v-model="selectedRequests" class="size-[16px] cursor-pointer static opacity-100 mb-1"/> -->
                    <span :class="['px-4 py-1 inline-flex items-center gap-x-[6px] rounded-xl',{'text-[#099556] bg-[#0995562e]':Number(slotProps.value.split('/')[1]) == 1,'text-[#fa9832] bg-[#fa993231]':Number(slotProps.value.split('/')[1]) == 0}]">
                        <div :class="['size-[8px] rounded-full',{'bg-[#099556]':Number(slotProps.value.split('/')[1]) == 1,'bg-[#fa9832]':Number(slotProps.value.split('/')[1]) == 0}]"/>
                        {{ slotProps.value.split('/')[0] }}
                    </span>
                </span>
                <span v-else-if="slotProps.cellNumber == 1">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span>
                        </div>
                    </div>
                </span>
                <span v-else-if="slotProps.cellNumber == 2">
                    {{ formatDate(slotProps.value) }}
                </span>
                <span v-else-if="slotProps.cellNumber == 3">
                    <span class="px-4 py-1 rounded-xl">{{ formatDate2(slotProps.value) }}</span>
                </span>
                <span v-else-if="slotProps.cellNumber == 4" class="flex flex-wrap items-center justify-center">
                    <!-- <span class="px-3 py-1 rounded-lg bg-[#d7e6fe] text-[#1e265c]">Niveau 1</span>
                    <span class="px-3 py-1 rounded-lg bg-[#fcdfc0] text-[#442511]">Niveau 2</span>
                    <span class="px-3 py-1 rounded-lg bg-[#c7f3de] text-[#183726]">Niveau 3</span> -->
                    <!-- <button class="px-6 py-3 rounded-xl text-white bg-[#3c41e9]">Voir les détails</button> -->
                    <validationDetail :request="slotProps.value"/>
                    <!-- <span class="text-[12px] font-extralight px-3"> -->
                        <!-- @{{ slotProps.value.split('/')[0] }} -->
                    <!-- </span> -->
                </span>
                <!-- <span v-else-if="slotProps.cellNumber == 5">
                    <button class="size-[25px] rounded-xl border flex justify-center items-center">
                        <Ellipsis :size="16" strokeWidth="1.3"/>
                    </button>
                </span> -->
                <span v-else>{{ slotProps.value }}</span>
            </template>
            <template #bottom-popup>
                <!-- <Transition @before-enter="beforeEnterBar" @enter="enterBar" @leave="leaveBar">
                <div v-if="selectedRequests.length >= 1" class="fixed bottom-6 left-[30%] h-[45px] rounded-2xl min-w-[650px]
                     hover:shadow-xl text-slate-300 shadow-md
                    border-[1.58px] border-zinc-600 bg-zinc-950 flex items-center px-4 font-light">
                        <div class="grow"><p class="text-center"><span class="text-white">{{ selectedRequests.length }}</span> sur <span class="text-white">{{ requests.length }}</span> sélectionnées</p></div>
                        <button v-on:click="toggleAllSelection" class="text-[#ffffff] border-l border-l-zinc-600 h-full px-6 flex items-center">Tout sélectionnées</button>
                        <button class="text-[#ffffff] border-l border-l-zinc-600 h-full px-6 flex items-center gap-x-[12px]"><Check color="#ffffff" :size="16" strokeWidth="1.3"/> Valider</button>
                        <button class="text-[#ee4636] border-l border-l-zinc-600 h-full px-6 flex items-center gap-x-[12px]"><X color="#ee4636" :size="16" strokeWidth="1.3"/> Rejeter</button>
                </div>
                </Transition> -->
            </template>
        </CustomTable>
    </div>
</template>

<script>

import Swal from 'sweetalert2'
import API from '@/service/API'
import CustomTable from './Custom-table.vue';
import {createColumnHelper} from "@tanstack/vue-table";
import { convertirDateEnFrancais, advancedFormat } from '@/utils/date-format';
import {SlidersHorizontal,RefreshCw,FolderUp,FlagTriangleLeft,X,Check} from "lucide-vue-next";
import gsap from "gsap";
import validationDetail from '../btn/validation-detail.vue';

const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => `${row.motif.text}/${row.exception.is_perm}/${row.id}`, {
    id: 'désignation',
    header: 'Désignation',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.user.first_name}/${row.exception.user.last_name}/${row.exception.user.email}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'Date requête',
    header: 'Date requête',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.date_start}T${row.exception.date_end}`, {
    id: 'Date de debut/fin',
    header: 'Date de début/fin',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'validation',
    header: 'Niveau de validation',
    cell: info => info.getValue(),
  })
];

export default {
    name: 'RequestTableComponent',
    components: {
        SlidersHorizontal,
        RefreshCw,
        CustomTable,
        validationDetail,
        X,Check,FlagTriangleLeft,FolderUp
    },
    data() {
        return {
            columnn: columnsRequest,
            table_load: false,
            actu_load: false,
            show_advanced: false,
            filter_status: 'attente',
            requests: [],
            toSend: { filter: '0', start: null, end: null },
        }
    },
    mounted() {
        this.getData()
    },
    created() {

    },
    methods: {
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        },
        async getData(type = null) {
            this.table_load = true;
            if(type == 'refresh') this.actu_load = true;
            await API.post('getAllRequests', this.toSend)
                .then((res) => {this.requests = res.data.data})
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{
                    this.table_load = false;
                    if(type == 'refresh') this.actu_load = false;
                })
        },
        selectFilter(nb,value){
            if(this.filter_status == value) return;
            this.filter_status = value;
            this.toSend = { ...this.toSend, filter: nb };
            this.getData();
        },
        validateRequest(id) {

            Swal.fire({
                title: 'Valider la requête ?',
                text: "Vous pouvez modifier le statut plutard",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('validateRequest/' + id)
                        .then(async (res) => {
                            // console.log(res.data)
                            if (res.data.status) {
                                await this.getData()
                                Swal.fire(
                                    'Succès !',
                                    'Requête validée avec succès',
                                    'success'
                                )
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            Swal.fire(
                                'Oops..',
                                error.response.data.message,
                                'erroe'
                            )
                            this.table_load = false
                        })
                }
            })
        },

        async rejectRequest(id) {

            const { value: motif } = await Swal.fire({
                title: 'Pourquoi voulez-vous rejeter la requête ?',
                input: 'text',
                inputLabel: '',
                inputPlaceholder: 'motif de rejet..',
                inputAttributes: {
                    minlength: 5,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                }

            })

            if (motif) {
                API.post('rejectRequest/' + id, { reject_motif: motif })
                    .then(async (res) => {
                        console.log(res.data)
                        if (res.data.status) {
                            await this.getData()
                            Swal.fire(
                                'Succès !',
                                'Requête rejetée avec succès',
                                'success'
                            )
                        } else {
                            Swal.fire(
                                'Oops..',
                                res.data.message,
                                'error'
                            )
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        Swal.fire(
                            'Oops..',
                            error.response.data.message,
                            'erroe'
                        )
                        this.table_load = false
                    })
            }
        },
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        // toggleAllSelection() {
        //     this.selectedRequests = [...this.requests.map(req => req.id)];
        //     console.log(this.selectedRequests);
        // },
        // beforeEnterBar(el){
        //     gsap.set(el, {
        //         scale: 0.97,
        //         yPercent: 10,
        //         opacity: 0
        //     });
        // },
        // enterBar(el, done){
        //     gsap.to(el, {
        //         scale: 1,
        //         yPercent: 0,
        //         opacity: 1,
        //         duration: 0.15,
        //         ease: "power2.out",
        //         onComplete: done,
        //     });
        // },
        // leaveBar(el, done){
        //     gsap.to(el, {
        //         scale: 0.95,
        //         yPercent: 10,
        //         opacity: 0,
        //         duration: 0.15,
        //         ease: "power2.out",
        //         onComplete: done,
        //     });
        // },
    }
}

</script>